import { render, staticRenderFns } from "./VideosSendNotification.vue?vue&type=template&id=32f5806e&"
import script from "./VideosSendNotification.vue?vue&type=script&lang=js&"
export * from "./VideosSendNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports